import type { IconSvgObject } from './types';

const LookLeftIcon: IconSvgObject = [
  ["path", { d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 14C8.08779 14.6072 6.63545 15 4.99963 15C3.87389 15 3.3355 14.8139 2.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.625 8.387V8.91649M7.25 8.75C7.25 8.33579 7.41789 8 7.625 8C7.83211 8 8 8.33579 8 8.75C8 9.16421 7.83211 9.5 7.625 9.5C7.41789 9.5 7.25 9.16421 7.25 8.75Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LookLeftIcon;
